export default function WhatMakesDifferent() {
  const features = [
    {
      icon: 'ri-building-2-line',
      title: 'نموذج مدعوم من الجهات',
      description: 'شراكات استراتيجية مع الجهات لتوفير الموارد والدعم'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'وصول مجاني أو منخفض التكلفة',
      description: 'إزالة الحواجز المالية أمام المواهب والمبتكرين'
    },
    {
      icon: 'ri-user-star-line',
      title: 'وصول مباشر للمواهب',
      description: 'تواصل الجهات الراعية مباشرة مع المواهب الواعدة'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'تأثير اجتماعي قابل للقياس',
      description: 'نتائج واضحة وقابلة للتتبع في تطوير المواهب والابتكار'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content - Right Side */}
          <div className="order-2 lg:order-2">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              ما الذي يجعلنا مختلفين
            </h2>
            <p className="text-xl text-gray-600 mb-10 leading-relaxed">
              نموذج فريد يجمع بين المسؤولية الاجتماعية للشركات والاستثمار الاستراتيجي في المواهب
            </p>

            <div className="space-y-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex gap-4 items-start group"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${feature.icon} text-white text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image - Left Side */}
          <div className="order-1 lg:order-1">
            <div className="relative h-[500px] lg:h-[600px]">
              <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B6B]/20 to-[#FF8E53]/20 rounded-3xl transform rotate-3"></div>
              <img
                src="/partnership-model.png"
                alt="نموذج الشراكة"
                className="relative rounded-3xl shadow-2xl w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&h=700&fit=crop&q=80';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
